import React, { JSX, useEffect, useState } from 'react';
import { Field, ImageField, } from '@sitecore-jss/sitecore-jss-nextjs';
import NextImage from 'next/image';
import Constants from 'assets/utils/constant';
import ProfileBreadcrumb from '../shared/ProfileBreadcrumb';

type LocationHeroProps = {
  img?: ImageField;
  locationName?: string;
  locationTypes?: {
    value: Array<{
      name: string;
      fields?: {
        Description?: Field<string>;
      };
    }>;
  };
};

const getImageSrc = (img?: ImageField): string => {
  const value = img?.value as unknown;

  if (typeof value === 'string') {
    const match = value.match(/src=["']([^"']+)["']/);
    return match?.[1] || '';
  }

  if (
    value &&
    typeof value === 'object' &&
    'src' in value &&
    typeof value.src === 'string'
  ) {
    return value.src;
  }

  return '';
};

const getImageAlt = (img?: ImageField): string => {
  const value = img?.value as unknown;

  if (typeof value === 'string') {
    const match = value.match(/alt=["']([^"']*)["']/);
    return match?.[1] || '';
  }

  if (
    value &&
    typeof value === 'object' &&
    'alt' in value &&
    typeof value.alt === 'string'
  ) {
    return value.alt;
  }

  return '';
};

const LocationHero = (props: LocationHeroProps): JSX.Element => {
  const fallbackImage = Constants.fallbackImages.location;

  const locationImageSrc = getImageSrc(props.img) || fallbackImage;

  const locationImageAlt =
    getImageAlt(props.img) ||
    props.locationName ||
    'Location exterior';

  const descriptionValue =
  props.locationTypes?.value?.[0]?.fields?.Description?.value;

  const locationTypeName =
    typeof descriptionValue === 'string' &&
    descriptionValue.trim().length > 0
      ? descriptionValue
      : props.locationTypes?.value?.[0]?.name || '';

  const [imageSrc, setImageSrc] = useState(locationImageSrc);

  useEffect(() => {
    setImageSrc(locationImageSrc);
  }, [locationImageSrc]);

  return (
    <div className="overhauled">
      <div className="bg-primary location-hero">
        <div className="top-section jss-inner-container">
          <ProfileBreadcrumb
            searchType="locations"
            name={props.locationName || ''}
          />

          <div
            className="hero-inner"
            itemScope
            itemType="https://schema.org/Place"
          >
            <div className="location-profile-image">
              <NextImage
                itemProp="image"
                src={imageSrc}
                alt={locationImageAlt}
                fill
                sizes="(max-width: 575px) 304px, (max-width: 767px) 358px, (max-width: 1023px) 338px, (max-width: 1199px) 419px, (max-width: 1439px) 444px, 521px"
                style={{ objectFit: 'cover' }}
                unoptimized={true}
                onError={() => setImageSrc(fallbackImage)}
              />
            </div>

            <div className="result-top">
              <div className="result-details">
                {locationTypeName && (
                  <p className="location-type">
                    {locationTypeName}
                  </p>
                )}
                {props.locationName && (
                  <h1 className="result-name" itemProp="name">
                    {props.locationName}
                  </h1>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationHero;